import type { ChangeEventHandler } from 'react'
import { cn } from '@/shared/lib/utils'
import { Textarea } from '../ui/textarea'
import { useField } from './form-context'
import { validateThereNotices } from './form-messages'

export interface InputProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {}

export const FormTextArea = ({
  onChange,
  disabled = false,
  type = 'text',
  className,
  ...props
}: InputProps) => {
  const { id, messages, name, required, disabled: disabledField } = useField()
  const isDisabled = disabled || disabledField
  const hasMessages = validateThereNotices(messages)
  const ariaDescription = hasMessages ? `${id}-messages` : `${id}-desc`

  const handleChange: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    if (isDisabled) return
    if (onChange) onChange(e)
  }

  return (
    <Textarea
      id={id}
      name={name}
      required={required}
      disabled={isDisabled}
      onChange={handleChange}
      aria-required={required}
      aria-describedby={ariaDescription}
      aria-invalid={hasMessages}
      aria-disabled={isDisabled}
      className={cn(['uppercase', className])}
      {...props}
    />
  )
}

FormTextArea.displayName = 'FormTextArea'
